import type { EditorState } from '@tiptap/pm/state'

export type MentionTriggerType = 'user' | 'model'

export const normalizeSuggestionRange = (
    state: EditorState,
    range: { from: number; to: number },
    triggerType?: MentionTriggerType,
) => {
    const docSize = state.doc.content.size
    let from = Math.max(0, Math.min(range.from, docSize))
    let to = Math.max(from, Math.min(range.to, docSize))

    if (triggerType === 'model') {
        const rangeStart = state.doc.textBetween(from, Math.min(to, from + 2), '', '')
        const previousChar = from > 0 ? state.doc.textBetween(from - 1, from, '', '') : ''
        const firstChar = from < to ? state.doc.textBetween(from, from + 1, '', '') : ''

        if (!rangeStart.startsWith('@@') && previousChar === '@' && firstChar === '@') {
            from -= 1
        }
    }

    const cursor = state.selection.empty ? state.selection.from : to
    const staysInTriggerParent = state.doc.resolve(from).sameParent(state.selection.$from)
    if (cursor > to && staysInTriggerParent) {
        const liveTrigger = state.doc.textBetween(from, cursor, '', '')
        const liveTriggerPattern =
            triggerType === 'model' ? /^@@[a-zA-Z0-9\-_.]*$/ : /^@(?!@)[a-zA-Z0-9\-_.]*$/

        if (liveTriggerPattern.test(liveTrigger)) {
            to = cursor
        }
    }

    return { from, to }
}
